export default __webpack_public_path__ + "static/media/check-in-banner.aa030ded.webp";